import { IAvailableLocaleTypes } from '@/types/locale.types';
import { CustomSearchServiceHits } from '@/types/product.types';
import { getProductSearchResultFromTypeSense } from '@/utils/product.util';

import { SearchServiceResult } from '../../types/search.types';

export class SearchDataProcessor {
  private locale: IAvailableLocaleTypes;

  constructor(locale: IAvailableLocaleTypes) {
    this.locale = locale;
  }

  processInitialSearchResults(
    searchResp: SearchServiceResult,
    isAdvanceSearch?: boolean
  ) {
    const productIds =
      searchResp?.hits?.map((item) => item.document?.productId) || [];
    const totalProducts = searchResp?.found;
    const updatedDataHits = this.createLoadingHits(
      searchResp.hits,
      isAdvanceSearch ?? false
    );
    const finalProducts = getProductSearchResultFromTypeSense(
      updatedDataHits,
      this.locale
    );
    const boostedCategory = this.getBoostedCategory(this.locale, searchResp);

    return {
      productIds,
      initialProducts: finalProducts,
      boostedCategory,
      totalProducts,
    };
  }

  private createLoadingHits(
    hits: CustomSearchServiceHits[],
    isAdvanceSearch: boolean
  ) {
    return hits.map(({ document }) => ({
      document: {
        ...document,
        isAdditionalProductInfoLoading: true,
        isAdvanceSearch,
      },
    }));
  }

  private getBoostedCategory(
    locale: IAvailableLocaleTypes,
    searchResp: SearchServiceResult
  ) {
    const boostedValue =
      locale === IAvailableLocaleTypes.EN
        ? searchResp?.request_params?.boostedInternalCategoryEn
        : searchResp?.request_params?.boostedInternalCategory;
    return boostedValue;
  }
}
